import { render, staticRenderFns } from "./TVShowMain.vue?vue&type=template&id=ab2f5832&scoped=true&"
import script from "./TVShowMain.vue?vue&type=script&lang=js&"
export * from "./TVShowMain.vue?vue&type=script&lang=js&"
import style0 from "./TVShowMain.vue?vue&type=style&index=0&id=ab2f5832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2f5832",
  null
  
)

export default component.exports